interface UsersAdminFormLike {
    getRoot(): HTMLElement;
    getCreateButton(root?: ParentNode): HTMLButtonElement | null;
    getSearchEl(): Element | null;
    getRoleFilterEl(): Element | null;
    getUserStatusFilterEl(): Element | null;
    getIncludeDummyFilterEl(): Element | null;
    getListEl(): Element | null;
    getHistoryOverlay(): HTMLElement | null;
    getHistoryCloseButtons(): HTMLElement[];
    getCreateOverlay(): HTMLElement | null;
    getCreateCloseButtons(): HTMLElement[];
    getCreateForm(): HTMLFormElement | null;
}

interface UsersAdminHandlerLike {
    applyFilters(): void;
    handleListClick(event: MouseEvent): void;
    handleListChange(event: Event): void;
    closeHistoryModal(): void;
    openCreateModal(): void;
    closeCreateModal(): void;
    submitCreateForm(event: SubmitEvent): Promise<void>;
}

export class UsersAdminListener {
    public form: UsersAdminFormLike;

    public handler: UsersAdminHandlerLike;

    public constructor(form: UsersAdminFormLike, handler: UsersAdminHandlerLike) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        const root = this.form.getRoot();
        if (root.dataset.usersAdminBound === "1") {
            return;
        }
        root.dataset.usersAdminBound = "1";

        const createBtn = this.form.getCreateButton();
        if (createBtn instanceof HTMLButtonElement) {
            createBtn.addEventListener("click", () => this.handler.openCreateModal());
        }

        const listEl = this.form.getListEl();
        if (listEl instanceof HTMLElement) {
            listEl.addEventListener("click", (event) => this.handler.handleListClick(event));
            listEl.addEventListener("change", (event) => this.handler.handleListChange(event));
        }

        const roleEl = this.form.getRoleFilterEl();
        if (roleEl instanceof HTMLSelectElement) {
            roleEl.addEventListener("change", () => roleEl.form?.requestSubmit());
        }

        const userStatusFilterEl = this.form.getUserStatusFilterEl();
        if (userStatusFilterEl instanceof HTMLSelectElement) {
            userStatusFilterEl.addEventListener("change", () => userStatusFilterEl.form?.requestSubmit());
        }

        const includeDummyFilterEl = this.form.getIncludeDummyFilterEl();
        if (includeDummyFilterEl instanceof HTMLInputElement) {
            includeDummyFilterEl.addEventListener("change", () => includeDummyFilterEl.form?.requestSubmit());
        }

        const historyOverlay = this.form.getHistoryOverlay();
        if (historyOverlay instanceof HTMLElement) {
            historyOverlay.addEventListener("click", () => this.handler.closeHistoryModal());
        }

        this.form.getHistoryCloseButtons().forEach((button) => {
            button.addEventListener("click", () => this.handler.closeHistoryModal());
        });

        const createOverlay = this.form.getCreateOverlay();
        if (createOverlay instanceof HTMLElement) {
            createOverlay.addEventListener("click", () => this.handler.closeCreateModal());
        }

        this.form.getCreateCloseButtons().forEach((button) => {
            button.addEventListener("click", () => this.handler.closeCreateModal());
        });

        const createForm = this.form.getCreateForm();
        if (createForm instanceof HTMLFormElement) {
            createForm.addEventListener("submit", (event) => {
                void this.handler.submitCreateForm(event);
            });
        }

        document.addEventListener("languageChanged", () => this.handler.applyFilters());
    }
}
